<template>
    <div class="page-content">

        <div id="soundlist" class="section grow bg-svg-lighthousesea">
            <div class="overlay opacity-50"></div>
            <div class="container h-100">
                <div class="d-flex h-100 text-center align-items-center">
                    <div class="w-100 color-white">
                        <h1 class="title color-white mb-5">Sleep Jar Premium</h1>
                        <p class="lead mb-5">Unlock all Sleep Jar content and features with Premium Membership!</p>
                        <!--<p class="lead mb-5"><small class="opacity-50">Just $3.99/mo or $19.99/yr (US) before taxes and elegible discounts.</small></p>-->
                        <!--<p class="lead mb-10">Premium members enjoy</p>-->

                        <div class="section-title col-lg-12 col-md-12 ml-auto mr-auto">
                            <div class="table-responsive align-items-center text-right">
                                <table class="table table-striped premium-comparison-table">
                                    <thead>
                                        <tr>
                                            <th scope="col" class="text-right"></th>
                                            <th scope="col" class="text-center">
                                                <span class="d-block">Free</span>
                                            </th>
                                            <th scope="col premium-highlight" class="text-center premium-highlight">
                                                <span class="d-block">Premium</span>
                                                <span class="badge badge-light">$19.99/yr*</span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <span>HD Audio</span>
                                                <audio ref="hdDemoAudio" v-on:ended="audioEnded('hd')">
                                                    <source :src="hdDemoAudioUrl"/>
                                                </audio>
                                                <span class="ml-3 lead btn-sound" :class="[buttonClass('hd'), colorClass('hd')]" v-on:click="togglePlayback('hd')"><i class="fas mr-2" :class="[buttonIconClass('hd')]"></i>{{buttonText('hd')}}</span>
                                            </td>
                                            <td><i class="fas fa-times text-danger"></i></td>
                                            <td class="premium-highlight"><i class="fas fa-check text-success"></i></td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <span>Sound Mixing</span>
                                                <audio ref="mixDemoAudio" v-on:ended="audioEnded('mix')">
                                                    <source :src="mixDemoAudioUrl"/>
                                                </audio>
                                                <span class="ml-3 lead btn-sound" :class="[buttonClass('mix'), colorClass('mix')]" v-on:click="togglePlayback('mix')"><i class="fas mr-2" :class="[buttonIconClass('mix')]"></i>{{buttonText('mix')}}</span>
                                            </td>
                                            <td><i class="fas fa-times text-danger"></i></td>
                                            <td class="premium-highlight"><i class="fas fa-check text-success"></i></td>
                                        </tr>
                                        <tr>
                                            <td>Narration Background Sounds</td>
                                            <td><i class="fas fa-times text-danger"></i></td>
                                            <td class="premium-highlight"><i class="fas fa-check text-success"></i></td>
                                        </tr>
                                        <tr>
                                            <td>Offline Listening (Android &amp; iOS)</td>
                                            <td><i class="fas fa-times text-danger"></i></td>
                                            <td class="premium-highlight"><i class="fas fa-check text-success"></i></td>
                                        </tr>
                                        <tr>
                                            <td>10-hour Gapless Playback (Alexa)</td>
                                            <td><i class="fas fa-times text-danger"></i></td>
                                            <td class="premium-highlight"><i class="fas fa-check text-success"></i></td>
                                        </tr>
                                        <tr>
                                            <td>Daily Meditation History (Android &amp; iOS)</td>
                                            <td><i class="fas fa-times text-danger"></i></td>
                                            <td class="premium-highlight"><i class="fas fa-check text-success"></i></td>
                                        </tr>
                                        <tr>
                                            <td>Cross-Platform Premium Access</td>
                                            <td><i class="fas fa-times text-danger"></i></td>
                                            <td class="premium-highlight"><i class="fas fa-check text-success"></i></td>
                                        </tr>
                                        <tr>
                                            <td>Monthly Content Drops</td>
                                            <td><i class="fas fa-times text-danger"></i></td>
                                            <td class="premium-highlight"><i class="fas fa-check text-success"></i></td>
                                        </tr>
                                        <tr>
                                            <td>Sounds</td>
                                            <td>{{ freeCounts.SOUND }}</td>
                                            <td class="premium-highlight">{{ premiumCounts.SOUND }}</td>
                                        </tr>
                                        <tr>
                                            <td>Stories</td>
                                            <td>{{ freeCounts.STORY }}</td>
                                            <td class="premium-highlight">{{ premiumCounts.STORY }}</td>
                                        </tr>
                                        <tr>
                                            <td>Meditations</td>
                                            <td>{{ freeCounts.MEDITATION }}</td>
                                            <td class="premium-highlight">{{ premiumCounts.MEDITATION }}</td>
                                        </tr>
                                        <tr>
                                            <td>Journeys</td>
                                            <td>{{ freeCounts.JOURNEY }}</td>
                                            <td class="premium-highlight">{{ premiumCounts.JOURNEY }}</td>
                                        </tr>
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td class="premium-highlight"><span class="badge badge-light">Free 2-week Trial</span></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <p class="lead mt-3 mb-0"><small class="opacity-50">* Pricing and promotions may vary by platform and region. First-time subscribers may be offered a free trial.</small></p>
                            <p class="lead"><small class="opacity-50">Stories, meditations, and journeys are not yet available on Fire TV.</small></p>
                        </div>

                        

                        <!--
                        <a href="https://www.amazon.com/dp/B092JRXVSX" target="_blank" class="btn btn-lg btn-light mt-10"><i class="fab mr-2 fa-amazon"></i>Click to subscribe on Amazon Alexa</a>

                        <p class="lead mt-3 mb-3 mt-2">or say</p>

                        <h3 class="title color-white mb-5 mt-0">"Alexa, ask Sleep Jar about premium"</h3>
                        -->

                        <!--
                        <p>In the two-step process, Alexa will tell you a brief overview of the benefits of Premium and ask if you're interested.</p>
                        <p>Say "yes" to hear the price (including any applicable discounts) and be asked if you would like to sign up.</p>
                        -->

                        <div class="section-title col-lg-12 col-md-12 ml-auto mr-auto mt-10">
                            <h4 class="mb-3 color-white">How do I purchase Sleep Jar Premium?</h4>
                            <p><span class="badge badge-light mr-2">Alexa</span>Just say <b>"Alexa, ask Sleep Jar about premium"</b>.</p>
                            <p><span class="badge badge-light mr-2">Android</span>Go to the settings page then tap "Upgrade to Premium".</p>
                            <p><span class="badge badge-light mr-2">iOS</span>Go to the settings page then tap "Upgrade to Premium".</p>
                            <p><span class="badge badge-light mr-2">Fire TV</span>Premium is not yet available on Fire TV.</p>
                        </div>

                        <div class="section-title col-lg-12 col-md-12 ml-auto mr-auto mt-10">
                            <h4 class="mb-3 color-white">How much does Sleep Jar Premium cost?</h4>
                            <p>Sleep Jar Premium is just $19.99/yr or $3.99/mo (US) before taxes or promotional discounts.<br/>It's more convenient and more affordable than a weekly Starbucks coffee!</p>
                        </div>

                        <div class="section-title col-lg-12 col-md-12 ml-auto mr-auto mt-10">
                            <h4 class="mb-3 color-white">How do I enable premium audio quality and extended loops?</h4>
                            <p><span class="badge badge-light mr-2">Alexa</span>Premium audio quality and extended loops are automatically enabled with our Premium Membership plan.</p>
                            <p><span class="badge badge-light mr-2">Android</span>Premium audio quality on Android is automatically enabled with an active Sleep Jar Premium subscription.</p>
                            <p><span class="badge badge-light mr-2">iOS</span>Premium audio quality on iOS is automatically enabled with an active Sleep Jar Premium subscription.</p>
                            <p><span class="badge badge-light mr-2">Fire TV</span>Premium is not yet available on Fire TV.</p>
                        </div>

                        <div class="section-title col-lg-12 col-md-12 ml-auto mr-auto mt-10">
                            <h4 class="mb-3 color-white">How do I mix sounds together?</h4>
                            <p><span class="badge badge-light mr-2">Alexa</span>Say <b>"Alexa, open Sleep Jar"</b>. When asked which sound you would like, say something like <b>"play rain sounds and ocean waves"</b>.</p>
                            <p><span class="badge badge-light mr-2">Android</span>Mix sounds by tapping the "+" button while a sound is playing.</p>
                            <p><span class="badge badge-light mr-2">iOS</span>Mix sounds by tapping the "+" button while a sound is playing.</p>
                            <p><span class="badge badge-light mr-2">Fire TV</span>This feature is not yet available on Fire TV.</p>
                        </div>

                        <div class="section-title col-lg-12 col-md-12 ml-auto mr-auto mt-10">
                            <h4 class="mb-3 color-white">Does my Premium membership work across platforms?</h4>
                            <p>Yes! Premium membership works across Android, iOS, and Alexa (linking required). You can link Alexa to your Sleep Jar account by opening the settings view in Sleep Jar for Android or iOS and tapping "Link to Alexa".</p>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { EventBus } from '../event-bus.js';
import media from '../assets/media.js';
export default {
    data () {
        return {
            "is_playing": {
                "hd": false,
                "mix": false
            },
            media
        };
    },
    name: 'premium',
    metaInfo: {
        title: 'Premium Membership',
        meta: [
            {
                'name': 'description',
                'property': 'og:description',
                'content': 'Sleep Jar® Premium offers longer loops, the best audio quality, and the ability to mix sounds together. Click to learn more.'
            }
        ]
    },
    methods: {
        "stopAudio": function(type = "mix"){
            this.is_playing[type] = false;
            this.$refs[type + "DemoAudio"].pause();
        },
        "startAudio": function(type = "mix"){
            this.is_playing[type] = true;
            this.$refs[type + "DemoAudio"].currentTime = 0;
            this.$refs[type + "DemoAudio"].play();
        },
        "audioEnded": function(type = "mix"){
            this.stopAudio(type);
        },
        "togglePlayback": function(type = "mix"){
            if(this.is_playing[type]){
                // stop it
                this.stopAudio(type);
            }else{
                // start it
                this.startAudio(type);
            }
        },
        buttonClass: function(type = "mix"){
            return {
                "btn": true,
                "btn-sm": true,
                "btn-outline-light": !this.is_playing[type],
                "btn-light": this.is_playing[type]
            };
        },
        buttonIconClass: function(type = "mix"){
            return {
                "fa-play": !this.is_playing[type],
                "fa-stop": this.is_playing[type]
            };
        },
        colorClass: function(type = "mix"){
            return {
                "color-white": !this.is_playing[type],
                "color-purple": this.is_playing[type]
            };
        },
        buttonText: function(type = "mix"){
            return this.is_playing[type] ? "Stop" : "Demo";
        },
        countMediaByTier(maxTier) {
            const counts = { SOUND: 0, STORY: 0, MEDITATION: 0, JOURNEY: 0 };
            Object.values(this.media).forEach(item => {
                if ((!item.published_ts || new Date(item.published_ts).getTime() < new Date().getTime()) && item.tier < maxTier && counts[item.type] !== undefined) {
                    counts[item.type]++;
                }
            });
            return counts;
        },
    },
    computed: {
        hdDemoAudioUrl: function(){
            return "/audio/hd/hd.mp3";
        },
        mixDemoAudioUrl: function(){
            return "/audio/hd/mix.mp3";
        },
        freeCounts() {
            return this.countMediaByTier(2);
        },
        premiumCounts() {
            return this.countMediaByTier(6); // 6 to include all (tier <= 5)
        }
    },
    components: {
    },
    mounted(){
        EventBus.$on("audio-stop", function(index){
            this.$refs.previews[index].stopAudio();
        }.bind(this));
    }
}
</script>
